export function checkPermissons(itemPermissions, currentPermissions) {
  if (!itemPermissions) return true;
  return itemPermissions.some(p => currentPermissions.includes(p));
}

export function checkFeatureToggles(itemFeatureToggles, currentFeatureToggles) {
  if (!itemFeatureToggles) return true;
  return itemFeatureToggles.some(ft => currentFeatureToggles.includes(ft));
}
